<div *ngIf="size" class="loaderRingDs__cont" [ngStyle]="{ width: size, height: size }">
  <div class="loaderRingDs__bg"[ngStyle]="{ width: size, height: size }"></div>
  <ng-container *ngFor="let item of [].constructor(4)">
    <div class="loaderRingDs__item loaderRingDs__item--{{type}}" [ngStyle]="{
      width: size,
      height: size
    }">
    </div>
  </ng-container>
</div>